"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
require("./Page.css");
var icons_1 = require("@tiendanube/icons");
var classnames_1 = __importDefault(require("classnames"));
var Responsive_1 = __importDefault(require("../Responsive"));
var PageTitle_1 = __importDefault(require("../PageTitle"));
var __1 = require("..");
function Page(_a) {
    var children = _a.children, title = _a.title, headerNavigation = _a.headerNavigation, paginationPrevious = _a.paginationPrevious, paginationNext = _a.paginationNext, headerAction = _a.headerAction, primaryAction = _a.primaryAction, secondaryActions = _a.secondaryActions, headerLabels = _a.headerLabels, subtitle = _a.subtitle;
    var _b = React.useState(false), showTitle = _b[0], setShowTitle = _b[1];
    var renderPrimaryAction = primaryAction && (React.createElement(__1.Stack.Item, null, primaryAction === "skeleton" ? (React.createElement(__1.Button.Skeleton, null)) : (React.createElement(__1.Button, { onClick: primaryAction.onClick, appearance: "primary", icon: primaryAction.icon, iconPosition: primaryAction.iconPosition }, primaryAction.children))));
    var renderSecondaryActions = secondaryActions === null || secondaryActions === void 0 ? void 0 : secondaryActions.map(function (action, index) { return (React.createElement(__1.Stack.Item, { key: index }, action === "skeleton" ? (React.createElement(__1.Link.Skeleton, null)) : (React.createElement(__1.Link, { onClick: action.onClick, appearance: "secondary", icon: action.icon, iconPosition: action.iconPosition }, action.children)))); });
    var menuSecondaryActions = (secondaryActions || []);
    var menuPrimaryAction = primaryAction;
    var menuPrimaryActionIcon = null;
    if (menuPrimaryAction) {
        menuPrimaryActionIcon =
            menuPrimaryAction === "skeleton" ? (React.createElement(__1.Link.Skeleton, null)) : (React.createElement(__1.Link, { onClick: menuPrimaryAction.onClick, icon: menuPrimaryAction.icon }));
    }
    var menuPopover = __spreadArrays(menuSecondaryActions);
    if (menuPrimaryAction) {
        menuPopover.push(menuPrimaryAction);
        if (menuPrimaryAction !== "skeleton")
            menuPrimaryAction.appearance = "primary";
    }
    var renderNavigation = (React.createElement("div", { className: classnames_1.default("nimbus--page-navbar", {
            "is-scrolled": showTitle,
        }) },
        React.createElement("div", { className: "nimbus--page-navbar__back" }, headerNavigation && (React.createElement(__1.Button, { onClick: headerNavigation.onClick, icon: icons_1.ChevronLeftIcon, appearance: "secondary" }, headerNavigation.children))),
        React.createElement(Responsive_1.default, { displays: ["mobile"] },
            React.createElement("div", { className: "nimbus--page-navbar__title " + (showTitle ? "is-visible" : "") }, title === "skeleton" ? (React.createElement(__1.Text.Skeleton, null)) : (React.createElement(__1.Text, { appearance: "secondary", textAlign: "center", bold: true }, title)))),
        React.createElement("div", { className: "nimbus--page-navbar__toolbar" },
            React.createElement(Responsive_1.default, { displays: ["mobile"] },
                headerAction && (React.createElement(__1.Link, { appearance: headerAction.appearance, icon: headerAction.icon, onClick: headerAction.onClick, spinner: headerAction.spinner, disabled: headerAction.disabled }, headerAction.children)),
                menuSecondaryActions.length > 0 && (React.createElement(__1.Popover, { menu: menuPopover, name: "dropdownMenu", position: "right" })),
                menuSecondaryActions.length === 0 &&
                    menuPrimaryActionIcon &&
                    menuPrimaryActionIcon),
            paginationPrevious && paginationNext && (React.createElement(Responsive_1.default, { displays: ["tablet", "desktop"] },
                React.createElement(__1.Link, { onClick: paginationPrevious, icon: icons_1.ArrowLeftIcon }),
                React.createElement(__1.Link, { onClick: paginationNext, icon: icons_1.ArrowRightIcon }))))));
    var renderHeaderLabels = (React.createElement("div", { className: "nimbus--page-header__labels" },
        React.createElement(__1.Stack, { spacing: "tight" }, headerLabels === null || headerLabels === void 0 ? void 0 : headerLabels.map(function (label, index) { return (React.createElement(__1.Stack.Item, { key: index }, label === "skeleton" ? (React.createElement(__1.Label.Skeleton, null)) : (React.createElement(__1.Label, { id: label.id, appearance: label.appearance, icon: label.icon, label: label.label })))); }))));
    var targetID = React.useRef(null);
    React.useEffect(function () {
        var options = {
            threshold: 0.75,
        };
        var callback = function (entries) {
            if (entries[0].isIntersecting) {
                setShowTitle(false);
            }
            else
                setShowTitle(true);
        };
        var observer = new IntersectionObserver(callback, options);
        observer.observe(targetID.current);
        return function () {
            observer.disconnect();
        };
    }, []);
    return (React.createElement("div", { className: "nimbus--page" },
        React.createElement("div", { className: "nimbus--page-header" },
            renderNavigation,
            React.createElement("div", { className: "nimbus--page-heading", ref: targetID },
                React.createElement(Responsive_1.default, { displays: ["tablet", "desktop"] },
                    React.createElement(__1.Stack, null,
                        React.createElement(__1.Stack.Item, { fill: true }, title === "skeleton" ? (React.createElement(PageTitle_1.default.Skeleton, null)) : (React.createElement(PageTitle_1.default, { title: title }))),
                        renderSecondaryActions,
                        renderPrimaryAction)),
                React.createElement(Responsive_1.default, { displays: ["mobile"] },
                    React.createElement("div", { className: "nimbus--page-heading__main" },
                        title === "skeleton" ? (React.createElement(PageTitle_1.default.Skeleton, null)) : (React.createElement(PageTitle_1.default, { title: title })),
                        paginationPrevious && paginationNext && (React.createElement("div", { className: "nimbus--page-heading__pagination" },
                            React.createElement(__1.Link, { onClick: paginationPrevious, icon: icons_1.ArrowLeftIcon }),
                            React.createElement(__1.Link, { onClick: paginationNext, icon: icons_1.ArrowRightIcon }))))),
                subtitle && (React.createElement("div", { className: "nimbus--page-header__subtitle" }, subtitle === "skeleton" ? (React.createElement(__1.Text.Skeleton, null)) : (React.createElement(__1.Text, null, subtitle)))),
                renderHeaderLabels)),
        React.createElement("div", { className: "nimbus--page-content" }, children)));
}
exports.default = Page;
//# sourceMappingURL=Page.js.map